<div class="store-container">
  <h2 class="store-title">Store List</h2>
  <div class="store-filter-bar">
    <input
      type="text"
      class="store-search-input"
      placeholder="Search by name or email..."
      [(ngModel)]="storeSearchTerm"
      (ngModelChange)="onSearchChange()"
    />
  </div>
  <button
    class="btn btn-primary addStore"
    data-bs-toggle="modal"
    data-bs-target="#staticBackdrop"
  >
    Add Store
  </button>
  <table *ngIf="!loading && filteredStores().length > 0" class="store-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>IP Address</th>
        <th>Actions</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let store of paginatedStores"
        [class.deactivated-row]="!store.isActive"
        (mouseenter)="hoveredStore = store.email"
        (mouseleave)="hoveredStore = null"
      >
        <td>{{ store.name }}</td>
        <td>{{ store.email }}</td>
        <td>{{ store.ipAddress || "N/A" }}</td>
        <td>
          <ng-container *ngIf="store.isActive; else inactiveStore">
            <button
              class="btn btn-outline-danger me-2"
              [class.visible]="hoveredStore === store.email"
              type="button"
              (click)="deleteStore(store.storeId)"
            >
              Deactivate
            </button>
            <button
              class="btn btn-outline-secondary me-2"
              [class.visible]="hoveredStore === store.email"
              type="button"
              (click)="openAddUserModal(store.storeId)"
            >
              Add User
            </button>
            <button
              class="btn btn-outline-secondary"
              [class.visible]="hoveredStore === store.email"
              type="button"
              (click)="openStoreAdmins(store.storeId)"
            >
              Store Admins
            </button>
          </ng-container>
          <ng-template #inactiveStore>
            <span class="badge bg-secondary me-2">Deactivated</span>

            <button
              class="btn btn-outline-success btn-sm"
              type="button"
              (click)="activateStore(store.storeId)"
            >
              Activate
            </button>
          </ng-template>
        </td>
        <!-- <td class="token-cell">
                    <div class="copy-wrapper">
                      <button 
                        class="copy-btn" 
                        [class.visible]="hoveredStore === store.email" 
                        (click)="copyToken(store.apiKey)">
                        Copy Token
                      </button>
                    </div>
                  </td>                                                       -->
      </tr>
    </tbody>
  </table>
  <div
    class="no-stores center-container"
    *ngIf="!loading && filteredStores().length === 0"
  >
    No stores found.
  </div>

  <div
    class="pagination-container"
    *ngIf="filteredStores().length > pageSize && !loading"
  >
    <button
      class="btn btn-secondary"
      (click)="previousPage()"
      [disabled]="pageNumber === 1"
    >
      Previous
    </button>

    <button
      *ngFor="let page of visiblePages()"
      class="btn"
      [class.active]="page === pageNumber"
      (click)="goToPage(page)"
    >
      {{ page }}
    </button>

    <button
      class="btn btn-secondary"
      (click)="nextPage()"
      [disabled]="pageNumber >= totalPages()"
    >
      Next
    </button>
  </div>
</div>
<div
  class="modal fade"
  id="staticBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Add new store</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="onModalClose(); addStoreForm.resetForm()"
        ></button>
      </div>
      <form #addStoreForm="ngForm" novalidate>
        <div class="modal-body">
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Name</label
            >
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              name="storeName"
              [(ngModel)]="storeName"
              placeholder="Fast Pharm"
              [disabled]="disabled"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Email address</label>
            <input
              type="text"
              class="form-control"
              id="storeEmailInput"
              name="storeEmail"
              [(ngModel)]="storeEmail"
              placeholder="name@example.com"
              required
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              #storeEmailCtrl="ngModel"
              [disabled]="disabled"
            />

            <div
              class="text-danger mt-1"
              *ngIf="storeEmailCtrl.invalid && storeEmailCtrl.touched"
            >
              <small *ngIf="storeEmailCtrl.errors?.['required']">
                Email is required
              </small>
              <small *ngIf="storeEmailCtrl.errors?.['pattern']">
                Enter a valid email
              </small>
            </div>
          </div>
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Address</label
            >
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              name="storeAddress"
              [(ngModel)]="storeAddress"
              placeholder="California"
              [disabled]="disabled"
            />
          </div>
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Contact</label
            >
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              name="storeContact"
              [(ngModel)]="storeContact"
              placeholder="951-239-0523"
              [disabled]="disabled"
            />
          </div>
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >IP address</label
            >
            <input
              type="email"
              class="form-control"
              id="exampleFormControlInput3"
              name="storeIpAddress"
              [(ngModel)]="storeIpAddress"
              [disabled]="disabled"
            />
          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="onModalClose(); addStoreForm.resetForm()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="addStore()"
          [disabled]="disabled || addStoreForm.invalid"
        >
          Add Store
        </button>
      </div>
      <div *ngIf="token && isToken" class="token-display mt-2">
        <label class="form-label">Token:</label>
        <div class="input-group">
          <input type="text" class="form-control" [value]="token" readonly />
          <!-- <button class="btn btn-outline-secondary" type="button" (click)="copyToken(token)">Copy</button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="addUserModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5">Add new user</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="onModalClose(); addUserForm?.resetForm()"
        ></button>
      </div>

      <form #addUserForm="ngForm" novalidate>
        <div class="modal-body">
          <!-- Name -->
          <div class="mb-3">
            <label class="form-label">Name</label>
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              name="name"
              [(ngModel)]="name"
              placeholder="John Doe"
              [disabled]="disabled"
              required
            />
          </div>

          <!-- Email -->
          <div class="mb-3">
            <label class="form-label">Email address</label>
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput2"
              name="email"
              [(ngModel)]="email"
              placeholder="name@example.com"
              required
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              #emailCtrl="ngModel"
              [disabled]="disabled"
            />
            <div
              class="text-danger mt-1"
              *ngIf="emailCtrl && emailCtrl.invalid && emailCtrl.touched"
            >
              <small *ngIf="emailCtrl.errors?.['required']">
                Email is required
              </small>
              <small *ngIf="emailCtrl.errors?.['pattern']">
                Enter a valid email
              </small>
            </div>
          </div>

          <!-- IP Address -->
          <div class="mb-3">
            <label class="form-label">IP address</label>
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput3"
              name="ipAddress"
              [(ngModel)]="ipAddress"
              [disabled]="disabled"
            />
          </div>

          <!-- Role -->
          <div class="mb-3">
            <label class="form-label">Role</label>
            <select
              id="roleSelect"
              class="form-select"
              name="role"
              [(ngModel)]="selectedRole"
              [disabled]="disabled"
            >
              <option value="" disabled selected>Select role</option>
              <option value="StoreAdmin">StoreAdmin</option>
              <option value="StoreUser">StoreUser</option>
            </select>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            (click)="onModalClose(); addUserForm?.resetForm()"
          >
            Close
          </button>

          <button
            type="button"
            class="btn btn-primary"
            (click)="addUser()"
            [disabled]="disabled || !selectedRole || addUserForm.invalid"
          >
            Add User
          </button>
        </div>

        <!-- Token display (unchanged) -->
        <div *ngIf="username" class="mt-3 border rounded p-3">
          <div class="row align-items-center">
            <div class="col-md-10">
              <div class="mb-2">
                <label class="form-label">Token</label>
                <input class="form-control" [value]="token" readonly />
              </div>
              <div class="row g-2">
                <div class="col-md-6">
                  <input class="form-control" [value]="username" readonly />
                </div>
                <div class="col-md-6">
                  <input class="form-control" [value]="password" readonly />
                </div>
              </div>
            </div>
            <div class="col-md-2 d-grid">
              <button
                class="btn btn-outline-primary h-100"
                (click)="copyToken()"
              >
                Copy All
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="storeAdminsModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Store Admins</h5>
        <button class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <!-- Loading -->
        <div *ngIf="isLoadingAdmins" class="text-center text-muted">
          Loading store admins...
        </div>
        <!-- Empty -->
        <div
          *ngIf="!isLoadingAdmins && storeAdmins.length === 0"
          class="text-center text-danger fw-semibold"
        >
          No store admins found.
        </div>

        <table class="table table-bordered" *ngIf="storeAdmins.length > 0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Token</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let admin of storeAdmins">
              <td>{{ admin.name }}</td>

              <!-- <td>************</td> -->
              <td>{{ maskApiKey(admin.apiKey) }}</td>
              <td>
                <button
                  class="btn btn-sm btn-outline-primary"
                  (click)="copyAdminToken(admin.apiKey)"
                >
                  Copy
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loading" class="center-container">
  <ng-template [ngTemplateOutlet]="loadingState"></ng-template>
</div>
<ng-template #loadingState>
  <div class="loading">
    <div class="scanner-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        class="bi bi-upc-scan me-2 scanner-icon"
        viewBox="0 0 16 16"
      >
        <path
          d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z"
        />
      </svg>
      <div class="scanner-line"></div>
    </div>
  </div>
</ng-template>
